import { DatePipe } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import * as moment from 'moment';
import { BsModalRef } from 'ngx-bootstrap';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SortBy } from 'src/app/Enums/sortEnums';
import { AuditTrailFilterService, filterData } from 'src/app/shared/classes/filter';
import { AuditTrailService } from 'src/app/shared/services/audit-trail.service';
import { ConstantsService } from 'src/app/shared/services/Constants/constants.service';
import { DataContextService } from 'src/app/shared/services/data-context.service';
import { AppComponent } from 'src/app/app.component';
import * as fs from 'file-saver';
import * as _ from "underscore";
import { TrackerOmnitureService } from 'src/app/shared/services/tracker-omniture.service';
declare const ExcelJS: any;

@Component({
  selector: 'app-audit-configuration',
  templateUrl: './audit-configuration.component.html',
  styleUrls: ['./audit-configuration.component.less']
})
export class AuditConfigurationComponent implements OnInit {
  isPaginationChange: boolean = false;
  modalRef: BsModalRef;
  tableSetting: any;
  configList: any;
  private service_URL: any;
  countLength:number;
  filterData = {} as filterData;
  p: any = 1;
  totalCount: any;
  itemsperPage : number =10;
  regDateTimeTo:any;
  regDateTimeFrom:any;
  userName: any;
  configModel : any;
  actionPerformedOnList :any;
  actionPerformedOnArray: Array<any> = new Array();
  actionPerformedList :any;
  actionPerformedArray: Array<any> = new Array();
  private unsubscribe$ =new Subject<void>();
  fromDate: any; 
  toDate: any;
  title:string;
  dataForExcel = [];
  constructor(private appComponent: AppComponent,private trackeromnitureservice:TrackerOmnitureService,private http:HttpClient,private auditService :AuditTrailService,private _dataContextService: DataContextService,private datePipe: DatePipe) {
    this.service_URL=ConstantsService;
    this.filterData.page = 1; 
   }

  ngOnInit() {
    this.auditService.refreshPage
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe(() => {
        this.isPaginationChange = false;
        this.ResetAuditTrailObjects();
        this.getConfigurationData();   
    });
    this.auditService.refreshwithFilters
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe(() => {
        this.isPaginationChange = false;
        this.ResetAuditTrailObjects();
        this.getConfigurationData();
    });

    this.tableSetting = {
      columns: this.tableSettingColumns()
  }
  this.getConfigurationData();
  var username = localStorage.getItem('email');
  
  username = username.split('@')[0];
  this.trackeromnitureservice.trackPageloadData('audit-configuration',username);
  this.trackeromnitureservice.trackPage("pageView");
}

tableSettingColumns() {
  return [     
      {
          Id: 1,
          title: "Changed Attribute",
          sortBy: SortBy.ChangedAttribute,
          actionPerformedOnDropdown: true,
          isSortable: true,
          classes: "ui_size_md",
          isFilterApplied: false,
          displaysort: false,
          isFilterIcon: true,
          isOnlyFilter: true
      },
      {
        
        Id:2,
        title: "Message Text",
        classes: "ui_size_md_small",            
        isSortable: false,
        statusDropdown: true,               
        isFilterApplied: false,
        displaysort: false,
        isOnlyFilter: false,
        isFilterIcon: false

    },
    {
      Id: 3,
      title: "Action Performed",
      sortBy: SortBy.ActionPerformed,
      actionPerformedDropdown: true,
      isSortable: true,
      classes: "ui_size_md",
      isFilterApplied: false,
      displaysort: false,
      isFilterIcon: true,
      isOnlyFilter: true
  },
      {
         
        Id: 4,
        title: "Modified By",
        classes: "ui_size_md_small",
        isSortable: false,
        statusDropdown: true,               
        isFilterApplied: false,
        displaysort: false,
        isOnlyFilter: true,
        isFilterIcon: false
      },
      {
          Id:5,
          title: "Modified Date and Time",
          classes: "ui_size_md_small",            
          isSortable: true,
          requestTypeDropDown: true,
        // sortBy: SortBy.Reg,
          isFilterApplied: false,
          displaysort: false,
          isOnlyFilter: true,
          isFilterIcon: false
      }
     
  ];
}

toIsoString(date) {
  var tzo = -date.getTimezoneOffset(),
      dif = tzo >= 0 ? '+' : '-',
      pad = function(num) {
          return (num < 10 ? '0' : '') + num;
      };

  return date.getFullYear() +
      '-' + pad(date.getMonth() + 1) +
      '-' + pad(date.getDate()) +
      'T' + pad(date.getHours()) +
      ':' + pad(date.getMinutes()) +
      ':' + pad(date.getSeconds()) +
      dif + pad(Math.floor(Math.abs(tzo) / 60)) +
      ':' + pad(Math.abs(tzo) % 60);
}

PrepareUsersObj() {

  var ourDate = new Date();
  var pastDate = ourDate.getDate() - 7;
  ourDate.setDate(pastDate);

  // if(this.regDateTimeFrom == null)
  // { 
  //   this.regDateTimeFrom = new Date();
  //   this.regDateTimeFrom.setDate(this.regDateTimeFrom.getDate()-7);        
  // }
  // if(this.regDateTimeTo == null)
  // {
  //   this.regDateTimeTo = new Date();        
  // }

  let params = {  
      ChangedBy:AuditTrailFilterService.changeByList,
      FromDate:this.regDateTimeFrom == undefined ? (this.toIsoString(ourDate).slice(0,11) + '00:00:00.000Z') : (this.regDateTimeFrom.slice(0,11) + '00:00:00.000Z'),
      ToDate:this.regDateTimeTo == undefined ? (this.toIsoString(new Date()).slice(0,11) + '23:59:00.000Z') : (this.regDateTimeTo.slice(0,11) + '23:59:00.000Z'),
      SearchByName: this.userName==undefined?"":this.userName,
      ActionPerformed: AuditTrailFilterService.actionPerformedList,
      ActionPerformedOn: AuditTrailFilterService.actionPerformedOnList,
      ChangedDate:null,
      PageNo: this.filterData.page
       
  };

  return params;
}
    setIntialPageCount(totalrecords : number)
  {
      this.isPaginationChange = true;
      if (totalrecords > this.itemsperPage) {
          this.countLength = this.itemsperPage;
      }
      else {
          this.countLength = totalrecords;
      }
  }
  checkFilterOptions(filterArray,filterList)
  {
      if(filterArray)
      {
          filterArray.forEach(item => {
              item.description = item.name;
          })
      }
      if(filterList.length == 0){
         /* filterArray.forEach(item =>{
              item.isCheck = true;
          })*/
         
      }
      else{
          filterArray.forEach(item => {
              filterList.forEach(item1 =>{
                  if(item.description == item1){
                      item.isCheck = true;
                  }
              })
          })
          
      }
  }
    //Sorting popup
    showSortingPopup(obj) {
      this.tableSetting.columns.forEach(item => {
          if (item.Id != obj.Id) {
              item.displaysort = false;
          }
      })
     
      obj.displaysort = !obj.displaysort;
  }
  //get the action Performed On list from api
loadActionPerformedOnOptions(actionPerformedOndata : any) {   
  this.actionPerformedOnList = actionPerformedOndata;
  this.actionPerformedOnArray = actionPerformedOndata;  
  this.checkFilterOptions(this.actionPerformedOnArray,AuditTrailFilterService.actionPerformedOnList);     
  this.tableSetting.columns[0].isFilterIcon = true;
}
  //get the action Performed list from api
  loadActionPerformedOptions(actionPerformeddata : any) {
    this.actionPerformedList = actionPerformeddata;
    this.actionPerformedArray = actionPerformeddata;  
    this.checkFilterOptions(this.actionPerformedArray,AuditTrailFilterService.actionPerformedList);     
    this.tableSetting.columns[2].isFilterIcon = true;
  }
searchByName(val) {
  this.isPaginationChange = false;
  this.userName = val.username;
  this.filterData.page = 1;
  
  this.regDateTimeFrom = val.fdate;
  this.regDateTimeTo = val.edate;
  this.getConfigurationData();
}
getConfigurationData()
{
  let data = this.PrepareUsersObj();  
  this.http.post<any>(this.service_URL.AuditTrail.getconfigaudittrail,data)
    .subscribe((res) => {
      this.configModel=res
      this.configList=res.audits;
      this.totalCount = res.totalRecords;  
       //Removing duplicate data from list   
      const resultActionPerformedOn = Array.from(new Set(res.actionPerformedOnDetails.map(s => s.id)))
      .map(id => {
          return {
              id: id,
              name: res.actionPerformedOnDetails.find(s => s.id === id).name,         
          }
      }) 
      const resultActionPerformed = Array.from(new Set(res.actionPerformedDetails.map(s => s.id)))
      .map(id => {
          return {
              id: id,
              name: res.actionPerformedDetails.find(s => s.id === id).name,           
          }
      }) ;
       this.loadActionPerformedOnOptions(resultActionPerformedOn); 
       this.loadActionPerformedOptions(resultActionPerformed); 
       if(!this.isPaginationChange){this.setIntialPageCount(this.totalCount);}                  
  })     
  }

  checkFilterApplied(val) {
    this.isPaginationChange = false;
    if (val) {
        this.filterData.sortBy = AuditTrailFilterService.sortBy;
        this.filterData.sortOrder = AuditTrailFilterService.sortOrder;
        this.filterData.page = 1;
        this.p = 1;
        this.checkFilterValue();
        this.getConfigurationData();
    } else {
        this.configList = [];
    }
  }
  checkFilterValue() {
    this.tableSetting.columns.forEach(item => {
        if (AuditTrailFilterService.sortBy != item.sortBy) {
            item.isFilterApplied = false;
        }
    })
  }
  
  ResetAuditTrailObjects() {
    AuditTrailFilterService.actionPerformedList=[];
    AuditTrailFilterService.actionPerformedOnList=[];
    this.regDateTimeFrom=null;
    this.regDateTimeTo=null;
    this.userName = '';
    this.filterData.page = 1;
}

hideDropdowns() {
  _.each(this.tableSetting.columns, function (item) {
      item.displaysort = false;
  })
}

changeCurrentPage(event) {
  this.filterData.page = event.page;
  if ((this.totalCount / (this.filterData.page * this.itemsperPage) > 1)) {
      this.countLength = this.filterData.page * this.itemsperPage
  }
  else {
      this.countLength = this.totalCount;
  }
  this.getConfigurationData();
}

PrepareAuditObj() {
 if (this.fromDate == null) {
    this.fromDate = new Date();       
    this.fromDate.setDate(this.fromDate.getDate() - 7);
    this.fromDate=new Date(this.datePipe.transform(this.fromDate, 'yyyy/MM/dd').toString()).toISOString();
  }
  if (this.toDate == null) {
    this.toDate = new Date();
    this.toDate.setDate(this.toDate.getDate()+1);
    this.toDate=new Date(this.datePipe.transform(this.toDate, 'yyyy/MM/dd').toString()).toISOString();
  }
  let params = {
    ChangedBy:AuditTrailFilterService.changeByList,
    FromDate:this.regDateTimeFrom,
    ToDate:this.regDateTimeTo,
    SearchByName: this.userName==undefined?"":this.userName,
    ActionPerformed: AuditTrailFilterService.actionPerformedList,
    ActionPerformedOn: AuditTrailFilterService.actionPerformedOnList,
    PageNo: this.filterData.page
  };
  return params;
}

exportAuditData(val) {
  this.userName = val.username;
  this.fromDate = val.fromdate;
  this.toDate = val.todate;

  var ourDate = new Date();
  var pastDate = ourDate.getDate() - 7;
  ourDate.setDate(pastDate);

  let params = {
    ChangedBy: AuditTrailFilterService.changeByList,
    FromDate: this.regDateTimeFrom == undefined ? (ourDate.toISOString().slice(0, 11) + '00:00:00.000Z') : (this.regDateTimeFrom.slice(0, 11) + '00:00:00.000Z'),
    ToDate: this.regDateTimeTo == undefined ? (new Date().toISOString().slice(0, 11) + '23:59:00.000Z') : (this.regDateTimeTo.slice(0, 11) + '23:59:00.000Z'),
    SearchByName: this.userName == undefined ? "" : this.userName,
    ActionPerformed: AuditTrailFilterService.actionPerformedList,
    ActionPerformedOn: AuditTrailFilterService.actionPerformedOnList,
    PageNo: this.filterData.page
  };

  let data = this.PrepareAuditObj();
  let tokenNew = localStorage.getItem('accessToken');
  var headers = new HttpHeaders({
    'Authorization': `Bearer ${tokenNew}`
  });

  this.http.post<any>(this.service_URL.AuditTrail.exportauditdata, params, { headers: headers, responseType: 'blob' as 'json' })
    .subscribe(res => {
      const blob = new Blob([res], { type: 'application/vnd.ms-excel' });
      const title = 'AuditData' + moment().format('YYYYMMDDhhmmss');

      // Decode the content before exporting to Excel
      const reader = new FileReader();
      reader.onload = (e: any) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(e.target.result, 'text/html');
        const decodedContent = doc.documentElement.textContent;
        const decodedBlob = new Blob([decodedContent], { type: 'application/vnd.ms-excel' });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(decodedBlob);
        link.download = title;
        link.click();
      };
      reader.readAsText(blob);
    });
}
}
